import React from 'react';
import ReportViewer from "./base/ReportViewer";

const RapportPlanificationRepas = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Rapportplanificationrepasreport"} />
        </div>
    );
}
export default RapportPlanificationRepas;